var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'no-scroll' : _vm.$route.name === 'BigPalette'},attrs:{"id":"app"}},[(_vm.isLoading)?_c('svg-loader'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mr-white",class:{animateRight : _vm.showMrWhiteRight ,animateLeft : _vm.showMrWhiteLeft}}),_vm._v(" "),_c('transition',{attrs:{"duration":400,"mode":"out-in"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e9bec38","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 